import { useAuth0 } from "@auth0/auth0-react";
import { useCallback, useEffect } from "react";

export interface useGetValidAccessTokenReturnType {
  getValidAccessToken: () => Promise<string>;
}

const useGetValidAccessToken = (): useGetValidAccessTokenReturnType => {
  const { getAccessTokenSilently, logout, user } = useAuth0();

  const getValidAccessToken = useCallback(async () => {
    try {
      const accessToken = await getAccessTokenSilently();
      const decodedToken = JSON.parse(atob(accessToken.split(".")[1]));
      const expiryTime = decodedToken.exp * 1000;
      if (expiryTime >= Date.now()) {
        return accessToken;
      } else {
        logout({ returnTo: window.location.origin });
        return "";
      }
    } catch (error) {
      console.error("Error fetching access token:", error);
      logout({ returnTo: window.location.origin });
      return "";
    }
  }, [logout, getAccessTokenSilently]);

  useEffect(() => {
    if (user) getValidAccessToken();
  }, [user, getValidAccessToken]);

  return { getValidAccessToken };
};

export default useGetValidAccessToken;
